import { AxiosInstance } from 'axios';
import { parseProfessions, parseProfession, GetProfessions } from './utils';
import {
  GetProfession,
  ProfessionsMini,
  PromiseProfession,
  PromiseProfessions,
  ProfessionsStatusEnum,
} from './types';
import {
  ImageSizes,
  Item as ProgramsItem,
} from '@/components/parts/catalog/list';
import { Organization } from '@/pages/organizations/types';
import { ORGANIZATION_ROUTE } from '@/pages/organizations/const';

export const getProfessionsMiniData = (api: AxiosInstance) => ({
  getProfessionsMini: async (): Promise<ProfessionsMini> => {
    const { data } = await api.get(
      ProfessionsStatusEnum.EVENT_PROFESSIONS_MINI
    );
    return data;
  },
});

export const getProfessionsData = (api: AxiosInstance) => ({
  getProfessions: async (
    params: any,
    dataParser: Function = parseProfessions
  ): Promise<PromiseProfessions> => {
    const { data } = await api.get<GetProfessions>(
      ProfessionsStatusEnum.EVENT_PROFESSIONS,
      {
        params,
      }
    );
    return { ...data, data: dataParser(data.data) };
  },
});

export const getProfessionData = (api: AxiosInstance) => ({
  getProfession: async (
    id: string,
    dataParser: Function = parseProfession
  ): Promise<PromiseProfession> => {
    const { data } = await api.get<GetProfession>(
      `${ProfessionsStatusEnum.EVENT_PROFESSION}/${id}`
    );
    return { ...data, data: dataParser(data.data) };
  },
  getEmployers: async (params: any): Promise<any> => {
    const { data } = await api.get('organizationlist/get', {
      params,
    });
    return { ...data, data: parseEmployers(data.data) };
  },

  getEducationOrganizations: async (params: any): Promise<any> => {
    const { data } = await api.get('organizationlist/get', {
      params,
    });
    return { ...data, data: parseEmployers(data.data) };
  },
});
function parseEmployers(items: any) {
  return items
    .map(({ code, contacts, id, logo, name, cop_multi_name }: Organization): ProgramsItem => {
      const text = [(contacts && contacts.address) || ''];
      const result: ProgramsItem = {
        id,
        code,
        text,
        cop_multi_name,
        image: {
          small: logo,
          large: logo,
        },
        link: {
          name: ORGANIZATION_ROUTE,
          params: { code, id: String(id) },
        },
        title: name,
      };
      return result;
    })
    .map((item: any, index: any) => {
      const {
        id,
        ovz,
        image: { small, large },
      } = item;
      const doubled = false;
      const badgeData: Array<string> = [];
      if (ovz) badgeData.push('ovz');
      return {
        item: {
          id,
          doubled,
          bind: {
            ...item,
            showClose: false,
            imageBgDefault: false,
            imageBgColor: '#ffffff',
            imageBgSize: ImageSizes.CONTAIN,
            badge: badgeData,
            img: doubled ? large || small : small,
          },
        },
      };
    });
}
export const professionsService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getProfessionsMiniData(api),
    ...getProfessionsData(api),
    ...getProfessionData(api),
  };
};



// WEBPACK FOOTER //
// ./src/services/api/professions/professionsService.ts